import InactivityControllerViewImpl from './inactivity-controller.jsx';
import MojitoCore from 'mojito/core';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * Inactivity module provides to the user a dialog which will be displayed when user has no interaction to the app for a specific time.
 * This dialog has to options "Stay Logged In" and "Log Out" and an countdown. When the countdown is through then the user is logged out.
 *
 * @class Inactivity
 * @extends Mojito.Core.Presentation.UIControllerView
 * @memberof Mojito.Modules
 */

export default UIControllerView('Inactivity', InactivityControllerViewImpl);
